const showElem = (elem) => {
  elem.classList.remove('top-up-button_hide');
};

const hideElem = (elem) => {
  elem.classList.add('top-up-button_hide');
};

const scrollListener = () => {
  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const topUpButton = document.querySelector('.top-up-button');

    if (scrollY > 200) showElem(topUpButton);
    else hideElem(topUpButton);
  });
};

const clickHandler = (evt) => {
  evt.preventDefault();

  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};

const init = () => {
  const topUpButton = document.querySelector('.top-up-button');
  if (topUpButton && !topUpButton.classList.contains('_init')) {
    window.addEventListener('scroll', scrollListener);
    topUpButton.addEventListener('click', clickHandler);
    topUpButton.classList.add('._init');
  }
};

init();
